import * as React from 'react';

import {
  DatePicker,
  Dialog,
  FlatButton,
  RaisedButton,
  TextField,
  Toggle,
} from 'material-ui';

import JerseyRestApiService from '../../../JerseyRestApiService';
import { StudioAppConfig } from 'glance-datatypes';
import Utils from '../../../Utils';
import { connect } from 'react-redux';

const styles = {
  dialogContentStyle: {
    width: '400px',
  },
  addNewButton: {
    position: 'absolute',
    zIndex: 1,
  },
};

interface EditSegmentQueryProps {
  studioAppConfig: StudioAppConfig;
  handleClose: () => void;
  editDialogOpen: boolean;
  segmentQueryData: {
    createdAt: string;
    endAt: Date;
    segmentId: string;
    segmentName: string;
    startAt: Date;
    updatedAt: Date;
    expireAt: Date;
    query: string;
    email: string;
    source: string;
    target: string;
    active: boolean;
  };
  updateSegmentQuery: Function;
  showSnackbarMessage: Function;
  addMonths: Function;
  today: Date;
}

interface State {
  processing: boolean;
  segmentQuery: string;
  segmentExpiryDate: any;
  endAt: any;
  email: string;
}

class EditSegmentQuery extends React.Component<EditSegmentQueryProps, State> {
  constructor(props: EditSegmentQueryProps) {
    super(props);
    const { segmentQueryData } = this.props;
    this.state = {
      processing: false,
      segmentQuery: segmentQueryData.query,
      segmentExpiryDate: new Date(segmentQueryData.expireAt),
      email: segmentQueryData.email,
      endAt: new Date(segmentQueryData.endAt),
    };
  }

  onSegmentQueryChange = (key: any, value: any) => {
    this.setState({
      ...this.state,
      [key]: value,
    });
  };

  editSegmentQuery = (a) => {
    const { segmentQuery, email, segmentExpiryDate, endAt } = this.state;
    const { segmentQueryData, updateSegmentQuery, showSnackbarMessage } = this.props;

    const { source } = segmentQueryData;
    if ((!segmentQuery && source && (source === "query" || source === "staticquery")))  {
      showSnackbarMessage(`Query field is mandatory for ${source} source.`);
      return;
    }

    this.setState({
      ...this.state,
      processing: true,
    });

    const payload = {
      segmentId: segmentQueryData.segmentId,
      query: segmentQuery ? segmentQuery.replace(/[\r\n]+/gm, ' ') : '',
      lastUpdatedBy: this.props.studioAppConfig.currentToken.user.name,
      expireAt: Utils.getDateInYyyyMmDd(segmentExpiryDate),
      endAt: Utils.getDateInYyyyMmDd(endAt),
      email,
    };
    updateSegmentQuery(payload);
  };

  componentWillReceiveProps(nextProps: EditSegmentQueryProps) {
    const { handleClose, segmentQueryData } = nextProps;
    this.setState((state, props) => ({
      ...this.state,
      segmentQuery: segmentQueryData.query,
      email: segmentQueryData.email,
      segmentExpiryDate: new Date(segmentQueryData.expireAt),
      endAt: new Date(segmentQueryData.endAt),
      processing: false,
    }));
  }

  handleEndAt = (value: Date) => {
    let expiry = new Date(value);
    expiry.setDate(expiry.getDate() + 1);

    this.setState({
      ...this.state,
      segmentExpiryDate: expiry,
      endAt: value,
    });
  }

  handleExpiryDate = (value: Date) => {
    const { source, expireAt } = this.props.segmentQueryData;
    const expireAtObj =  new Date(expireAt);
    if (source === "staticquery") {
      if (expireAtObj > this.props.today) {
        this.onSegmentQueryChange('segmentExpiryDate', value);
      } else {
        this.props.showSnackbarMessage("No Modifications!! Today's date is passed the expiration date");
        this.onSegmentQueryChange('segmentExpiryDate', expireAtObj);
      }
    } else this.onSegmentQueryChange('segmentExpiryDate', expireAtObj);
  }

  render() {
    const { segmentQuery, email, processing, segmentExpiryDate, endAt } = this.state;
    const { handleClose, editDialogOpen, segmentQueryData, addMonths, today } = this.props;

    let endDate: Date = new Date(segmentQueryData.endAt);
    let expiryAt: Date = new Date(segmentQueryData.expireAt);
    let todayDate: Date = new Date();
    todayDate.setHours(0, 0, 0, 0);

    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={handleClose} />,
      <FlatButton
        label="Update"
        primary={true}
        onClick={this.editSegmentQuery}
        disabled={processing}
      />,
    ];

    return (
      <Dialog
        actions={actions}
        modal={false}
        open={editDialogOpen}
        onRequestClose={handleClose}
        autoScrollBodyContent={true}
        contentStyle={styles.dialogContentStyle}
      >
        <TextField
          id="segmentId"
          fullWidth={true}
          value={segmentQueryData.segmentId}
          floatingLabelText="Segment Id"
          disabled
        />

        <TextField
          id="segmentName"
          fullWidth={true}
          value={segmentQueryData.segmentName}
          floatingLabelText="Segment Name"
          disabled
        />
        <TextField
          id="target"
          fullWidth={true}
          value={segmentQueryData.target}
          floatingLabelText="Target"
          disabled
        />
        <TextField
          id="source"
          fullWidth={true}
          value={segmentQueryData.source}
          floatingLabelText="Source"
          disabled
        />
        {segmentQueryData.source != "staticquery" ?
          <div>
            <div>Starts At:</div>
            <DatePicker
              value={new Date(segmentQueryData.startAt)}
              container="inline"
              fullWidth={true}
              disabled
            />
            <div>Ends At:</div>
            <DatePicker
              value={new Date(endAt)}
              maxDate={addMonths(today)}
              container="inline"
              fullWidth={true}
              onChange = {(_e, value) => this.handleEndAt(value)}
              disabled = {segmentQueryData.source === 'staticquery' || endDate < todayDate}
            />
          </div>
        : <div>
           <div>Run Date:</div>
           <DatePicker
            value={new Date(segmentQueryData.startAt)}
            hintText="Run Date"
            container="inline"
            fullWidth={true}
            disabled
            />
          </div>}
        <div>Expiry Date:</div>
        <DatePicker
          value={new Date(segmentExpiryDate)}
          maxDate={addMonths(today)}
          hintText="Expiry Date"
          container="inline"
          fullWidth={true}
          onChange = {(_e, value) => this.handleExpiryDate(value)}
          disabled = {segmentQueryData.source !== 'staticquery' || expiryAt < todayDate}
        />
        <TextField
          id="editQuery"
          floatingLabelText="Query"
          value={segmentQuery}
          multiLine={true}
          rows={3}
          fullWidth={true}
          rowsMax={4}
          disabled={processing}
          onChange={(e, value) =>
            this.onSegmentQueryChange('segmentQuery', value)
          }
        />
        <TextField
          id="editEmail"
          fullWidth={true}
          value={email}
          floatingLabelText="Email Address"
          onChange={(e, value) => this.onSegmentQueryChange('email', value)}
        />

        <Toggle
          label="Status"
          toggled={segmentQueryData.active}
          disabled
        />
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    studioAppConfig: state.studioAppConfig,
  };
};

export default connect(mapStateToProps)(EditSegmentQuery);



// WEBPACK FOOTER //
// ./src/pages/segmentQuery/components/EditSegmentQuery.tsx